import type { z } from 'zod'

import type { ApiCartDiscountSchema } from '@/ducks/offers/offers.schema'

import type { CartDiscountCampaign } from './campaigns.types'

type CartDiscount = z.infer<typeof ApiCartDiscountSchema>[number]

const normalizeDiscountType = (value: string | undefined) =>
  value?.toLowerCase() === 'flat' ? 'Flat' : 'Percentage'

export const findCartDiscountByCampaign = (
  discounts: CartDiscount[] | undefined,
  campaign: CartDiscountCampaign
): CartDiscount | null => {
  if (!discounts?.length) return null

  const byCampaignId = discounts.find(
    discount => discount._id === campaign.campaignId
  )
  if (byCampaignId) return byCampaignId

  return (
    discounts.find(discount => {
      const typeMatch =
        campaign.discountType == null ||
        discount.discount_type === normalizeDiscountType(campaign.discountType)
      const amountMatch =
        campaign.amountPercentage == null ||
        discount.amount_percentage === campaign.amountPercentage
      const targetMatch =
        campaign.targetAmount == null ||
        discount.target_amount === campaign.targetAmount
      const maxOffMatch =
        campaign.maxOff == null || discount.max_off === campaign.maxOff
      const expiryMatch =
        campaign.expiryDate == null || discount.expiry_date === campaign.expiryDate

      return typeMatch && amountMatch && targetMatch && maxOffMatch && expiryMatch
    }) ?? null
  )
}

export const getCartDiscountId = (
  campaign: CartDiscountCampaign,
  discounts: CartDiscount[] | undefined
): string | null =>
  findCartDiscountByCampaign(discounts, campaign)?._id ?? null

export const mapCartDiscountToEditState = (discount: CartDiscount) => ({
  offerId: discount._id,
  initialDiscount: String(discount.amount_percentage),
  initialExpiration: discount.expiration_time,
  initialMinimumAmount: String(discount.target_amount),
  initialMaximumOff: String(discount.max_off),
  initialDiscountType:
    discount.discount_type === 'Percentage' ? 'Percentage' : 'Flat'
})
